import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Department } from "@enums/department.enum";
import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { environment } from "@environments/environment";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { DeliveryNote } from "@interfaces/deliveryNote.interface";
import { PurchaseLogLineItem } from "@interfaces/purchaseLogLineItem.interface";
import { Supplier } from "@interfaces/models/supplier.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { MachineService } from "@services/machine.service";
import { PurchaseLogService } from "@services/purchaseLog.service";
import { SiteService } from "@services/site.service";
import { WorkOrderStageService } from "@services/workOrderStage.service";
import { ToastService } from "angular-toastify";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "goodsDetail",
	styleUrls: ["goodsDetail.css"],
	templateUrl: "goodsDetail.html"
})
export class GoodsDetailComponent implements OnInit, OnDestroy {
	private clockIntervalId: any;
	dateTime = new Date;
	deliveryNotes: DeliveryNote[] = [];
	direction = 0;
	firstLoad = true;
	isLoading = false;
	machines: any[] = [];
	mode = 0;
	purchaseLogSuppliers: any[] = [];
	purchaseLogs: any[] = [];
	purchaseLogsOrig: any[] = [];
	purchaseTypes: any[] = [];
	quantityEntered = 0;
	selectedDeliveryNote = new DeliveryNote;
	selectedStage: any;
	showCustomerSent = false;
	showOutsideReceived = false;
	showOutsideSent = false;
	showPopup = false;
	site = "";
	siteId = 0;
	stages: any[] = [];
	private supplierLogoErrorIds = new Set<number | string>();
	supplierSearchTerm = "";
	supplierSelected = false;
	woSearchTerm = "";

	constructor(private route: ActivatedRoute, private toastService: ToastService, private router: Router, private appSettingsService: AppSettingsService, private siteService: SiteService, private plogService: PurchaseLogService, private machineService: MachineService, private workOrderStageService: WorkOrderStageService) {
		this.purchaseTypes = GetPropertiesFromEnum(PurchaseTypeEnum);
		this.appSettingsService.set("profileId", environment.build.flowId);
		this.route.params
			.subscribe(async (params) => {
				this.siteId = Number.parseInt(params.id);
				this.mode = Number.parseInt(params.mode);
				this.renderMode(Number.parseInt(params.mode));
			});
	}
	
	// eslint-disable-next-line @typescript-eslint/member-ordering
	ngOnInit(): void {
		// set immediately
		this.dateTime = new Date();
		// update every second
		this.clockIntervalId = setInterval(() => {
			this.dateTime = new Date();
		}, 1000);
	}

	// eslint-disable-next-line @typescript-eslint/member-ordering
	ngOnDestroy(): void {
		if (this.clockIntervalId) {
			clearInterval(this.clockIntervalId);
		}
	}

	// eslint-disable-next-line @typescript-eslint/member-ordering
	customerSent() {
		return "";
	}

	enterManual() {
		if (this.mode == 1) {
			const input = window.prompt("Enter PO Number", "0");
			console.log(input);
			if (input !== null) {
				this.router.navigate([`admin/webapps/purchaseDetail/${input}`]);
			}
		}
	}

	get filteredSuppliers(): Supplier[] {
		const term = this.supplierSearchTerm.trim().toLowerCase();
		if (!term) {
			return this.purchaseLogSuppliers;
		}
		return this.purchaseLogSuppliers.filter(s =>
			s.name.toLowerCase().includes(term)
		);
	}

	get filteredStages(): any[] {
		const term = this.woSearchTerm.trim().toLowerCase();
		if (!term) {
			return this.stages;
		}
		return this.stages.filter(s =>
			s.partNumber.toLowerCase().includes(term)
		);
	}

	getAllStages() {
		const stages: any[] = [];
		this.machines.forEach(machine => {
			if (this.direction == 0) {
				const rStages: [] = machine.runningStages;
				if (rStages.length > 3) {
					rStages.forEach((stage: any) => {
						if (stage.stageStarted === true) {
							stages.push({ ...stage });
							console.log(JSON.stringify(stage));
						}

					});
				}
			} else {
				const rStages: [] = machine.availableStages;
				if (rStages.length > 3) {
					rStages.forEach((stage: any) => {
						if (stage.quantityCompleted === 0 && this.direction == 1) {
							stages.push({ ...stage });
							console.log(JSON.stringify(stage));
						}

					});
				}

			}
		});
		this.stages = stages;
	}

	getOutsideDue() {
		this.firstLoad = false;
		this.machineService.app_OpsPlannerForDepartment(Department.Outsource)
			.subscribe(
				(res: any) => {
					const machinesTemp = res.response;
					this.machines = machinesTemp.filter((x: { machineId: number; }) => x.machineId != null);
					this.getAllStages();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	// getPlogs() {
	// 	this.firstLoad = false;
	// 	this.plogService.app_GetDue()
	// 		.subscribe(
	// 			(res: any) => {
	// 				this.purchaseLogsOrig = res.response;
	// 				this.purchaseLogsOrig.forEach((x) => {
	// 					this.purchaseLogSuppliers.push({ id: x.supplierId, name: x.supplier.name });
	// 				});
	// 				// eslint-disable-next-line prefer-const
	// 				this.purchaseLogSuppliers = this.purchaseLogSuppliers.filter((value, index, self) =>
	// 					index === self.findIndex((t) => (
	// 						t.id === value.id && t.name === value.name
	// 					))
	// 				);
	// 			},
	// 			(err) => {
	// 				console.log(err);
	// 				this.toastService.error("Something Went Wrong!");
	// 			}
	// 		);
	// }

	getPlogs() {
		this.firstLoad = false;
		this.plogService.app_GetDue()
			.subscribe(
				(res: any) => {
					this.purchaseLogsOrig = res.response;

					this.purchaseLogsOrig.forEach((x) => {
						this.purchaseLogSuppliers.push({
							id: x.supplierId,
							name: x.supplier.name
						});
					});

					// De-dupe suppliers
					this.purchaseLogSuppliers = this.purchaseLogSuppliers.filter((value, index, self) =>
						index === self.findIndex((t) => (
							t.id === value.id && t.name === value.name
						))
					);

					// Sort alphabetically by name
					this.purchaseLogSuppliers.sort((a, b) =>
						(a.name || "").localeCompare((b.name || ""), undefined, { sensitivity: "base" })
					);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getSupplierLogoUrl(name: string, supplierId?: number | string): string | null {
		// If we’ve already seen an error for this supplier, force fallback
		if (supplierId != null && this.supplierLogoErrorIds.has(supplierId)) return null;

		if (!name) return null;

		// logo.dev expects a slug-ish value in the URL
		const slug = encodeURIComponent(
			name
				.trim()
				.toLowerCase()
				.replace(/&/g, "and")
				.replace(/[^a-z0-9\s-]/g, "")
				.replace(/\s+/g, "-")
		);

		return `https://img.logo.dev/name/${slug}?token=pk_VmwfGmJkTyKosIBaRGhZFw`;
	}

	goBack() {
		if (this.direction == 0) {
			// Goods In
			this.router.navigate([`admin/webapps/goods/${this.siteId}/in`]);
		} else {
			// Goods Out
			this.router.navigate([`admin/webapps/goods/${this.siteId}/out`]);
		}
	}

	goMoveStock() {
		this.router.navigate(["admin/webapps/stockControl/2"]);
	}


	goPurchaseDetail(id: number) {
		this.router.navigate([`admin/webapps/purchaseDetail/${id}`]);
	}

	onSupplierLogoError(supplier: any): void {
		// Mark supplier as errored so we fallback next render
		if (supplier?.id != null) {
			this.supplierLogoErrorIds.add(supplier.id);
		}
	}

	outsideReceived() {
		console.log(this.quantityEntered);
		console.log(this.selectedStage.quantityCompleted);
		this.workOrderStageService.completedQuantityApiKey(this.selectedStage.id, this.quantityEntered - this.selectedStage.quantityCompleted)
			.subscribe(
				() => {
					this.toastService.success("Parts Logged Successfully!");
					this.getOutsideDue();
					this.showOutsideReceived = false;
					this.showPopup = false;
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
	}

	outsideSent() {
		this.workOrderStageService.completedQuantityApiKey(this.selectedStage.id, 1)
			.subscribe(
				() => {
					this.toastService.success("Parts Logged Successfully!");
					this.getOutsideDue();
					this.showOutsideSent = false;
					this.showPopup = false;
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
	}

	renderMode(mode: number) {
		if (mode < 4) {
			// In
			this.direction = 0;
		} else {
			// Out
			this.direction = 1;
		}
		switch (mode) {
			case 1:
				// In - Purchase
				if (this.firstLoad == true) {
					this.firstLoad = false;
					this.getPlogs();
				}
				return "Purchase";
			case 2:
				// In Outside Process
				if (this.firstLoad == true) {
					this.firstLoad = false;
					this.getOutsideDue();
				}
				return "Outside Process";
			case 3:
				// In - Internal
				return "Internal";
			case 4:
				//  Out - OUTSIDE PROCESS
				// In Outside Process
				if (this.firstLoad == true) {
					this.firstLoad = false;
					this.getOutsideDue();
				}
				return "Suppliers";
			case 5:
				// Out - Customer
				return "Customer";
			case 6:
				// Out - Internal
				return "Internal";
			default:
				this.direction = 999;
				return "UNKNOWN";
		}
	}

	renderPlogDueDate(date: string) {
		return new Date(date).toLocaleDateString("en-GB");
	}

	renderPlogLineItems(lineItems: string) {
		const lineItemsConverted: PurchaseLogLineItem[] = JSON.parse(lineItems);
		return (lineItemsConverted.length);
	}

	renderPlogType(id: number) {
		return this.purchaseTypes.filter(x => x.id == id)[0].name;
	}

	renderSite(id: number) {
		switch (id) {
			case 1:
				return "KINGS NORTON";
			case 2:
				return "SELLY OAK";
			case 3:
				return "REDDITCH";
			case 5:
				return "REDDITCH TOOLROOM";
			default:
				return "KINGS NORTON";
		}
	}

	selectDeliveryNote(dn: any) {
		this.selectDeliveryNote = dn;
		this.showCustomerSent = true;
		this.showPopup = true;
	}

	selectStage(stage: any) {
		if (this.direction == 0) {
			this.selectedStage = stage;
			this.showOutsideReceived = true;
			this.quantityEntered = stage.quantityRequired;
			this.showPopup = true;
		}
		else {
			this.selectedStage = stage;
			this.showOutsideSent = true;
			this.showPopup = true;
		}
	}

	selectSupplier(id: number) {
		this.purchaseLogs = this.purchaseLogsOrig.filter(x => x.supplierId === id);
		this.supplierSelected = true;
	}
}